<template>
    <v-col cols="12">
        <div class="ma-auto text-center mb-3">
            <p>Please enter the ZIP code and City where service is requested.</p>
            <small>Your zip ensures quotes are as accurate as possible for your area.</small>
        </div>
        <v-divider><i style="font-size:14px">Address</i></v-divider>
    </v-col>
    <v-col cols="12" md="6"  sm="12" xs="12">
        <v-text-field density="compact" :rules="rules" variant="outlined" v-model="form.address.street" label="Street *"/>
    </v-col>
    <v-col cols="12" md="6"  sm="12" xs="12">
        <v-text-field density="compact" :rules="rules" variant="outlined" v-model="form.address.city" label="City *"/>
    </v-col>
    <v-col cols="12" md="6"  sm="12" xs="12">
        <v-select density="compact" :rules="rules" variant="outlined" v-model="form.address.state" :items="states" label="State *"/>
    </v-col>
    <v-col cols="12" md="6"  sm="12" xs="12">
        <v-text-field density="compact" :rules="rules" variant="outlined" v-model="form.address.zip" label="ZIP Code *"/>
    </v-col>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { form, states } = storeToRefs(store)

const rules = [
  (v: any) => !!v || 'This field is required'
]
</script>
